import { useEffect, useState } from "react"

import { useAppSelector, useAppDispatch } from "../../app/hooks"

import { useTranslation, Trans } from "react-i18next"

import { setSearchKey } from "./searchSlice"

import { SearchForm } from "../../components/searchForm/SearchForm"

const MIN_SEARCH_LENGTH = 3

export function Search() {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const onChange = (value: string) => {
    if (value && value.length >= MIN_SEARCH_LENGTH) {
      dispatch(setSearchKey(value))
    } else {
      dispatch(setSearchKey(""))
    }
  }

  return (
    <SearchForm
      onChange={onChange}
      clearLabel={t("searchposition.clear")}
      placeholder={t("searchposition.placeholder")}
    />
  )
}
